import { 
    
    EXPORT_CREATED,
    EXPORT_LOADED,
    EXPORT_PROCESS_FAILED,
    EXPORT_PROCESS_LOADING,

} from '../actions/export';
  

const initialState = {
    isLoading: false,
    data: null,
    errors: null,
    isSuccess: false,
}

const exportReducer = (state = initialState, action) => {
    switch (action.type) {
        case EXPORT_LOADED:
            return {
                ...state,
                isLoading: false,
                data: action.payload.data,
                errors: null
            }
        case EXPORT_CREATED:
            return {
                ...state,
                // new: {
                    isLoading: false,
                    isSuccess: true,
                    errors: null
                // }
            }
        case EXPORT_PROCESS_LOADING:
            return {
                ...state,
                // new: {
                    isLoading: true,
                    isSuccess: false,
                    errors: null
                // }
            }
        case EXPORT_PROCESS_FAILED:
            return {
                ...state,
                // new: {
                    isLoading: false,
                    isSuccess: false,
                    errors: action.errors
                // }
            }
        default:
            return state;
    }
};
  
export default exportReducer;
  